/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
import React from 'react';
import { StyleSheet } from 'react-native';
import Image from '@web/components/common/Image';
import Colors from '~global/Colors';
const Input = React.lazy(() => import('@web-components/form/Input'));
import { useSelector } from 'react-redux';
const InputSearchBar = (props) => {
  const { $debounce } = global;
  const inputSearchText = useSelector(
    (state) => state.createReview.inputSearchText,
  );

  return (
    <Input
      onChangeText={$debounce(props.searchHandler, 500)}
      placeholder="What do you want to review?"
      defaultValue={inputSearchText}
      inputContainerStyle={styles.inputSearch}
      rightIcon={
        <Image
          style={styles.iconSearch}
          source={require('~assets/img/common/icon-search-review.png')}
        />
      }
      rightIconContainerStyle={{ paddingRight: 0 }}
    />
  );
};

const styles = StyleSheet.create({
  iconSearch: {
    width: 15,
    height: 15,
  },
  inputSearch: {
    backgroundColor: Colors.white,
    borderRadius: 10,
    height: 44,
  },
});

export default InputSearchBar;
